import React, {Component} from 'react';
import {translate} from "../../i18n/customI18nProvider";
import { withStyles } from '@material-ui/core/styles';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { Stack } from '@mui/material';

class MyPOSInEventTable extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const { myposInEvent } = this.props;
        let found = false;
        let row_data = [];
        let total_count = 0;
        let count;
        for(let i=0; i<myposInEvent.length; i++) {
            count = parseFloat(myposInEvent[i]['count']);
            let obj = {
                date: (new Date(myposInEvent[i]['date'])).toLocaleDateString(translate('custom.OPTIONS.i18n_date_format'), { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
                count: count
            }
            total_count += count;
            row_data.push(obj);
        }

        if (total_count > 0) {
            found = true;
        }

        if(found) {
            let view = (
                <>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <h1 className={this.props.classes.titleTextStyle}>{translate('custom.mypos_in_event')}</h1>
                        {/* export button */}
                    </Stack>
                    
                    <Box overflow="auto">
                        <Table style={{marginBottom: 20}} >
                            <TableHead className={this.props.classes.table_head} >
                                <TableRow>
                                    <TableCell className={this.props.classes.table_head_amount}>{translate('custom.count')}</TableCell>
                                    <TableCell className={this.props.classes.table_head}>{translate('custom.date')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {row_data.map((r_data, r_idx) => (
                                    <TableRow
                                        key={r_idx}
                                    >
                                        <TableCell className={this.props.classes.table_amount} numeric="true">{r_data['count']}</TableCell>
                                        <TableCell className={this.props.classes.table_row}>{r_data['date']}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </>
            );

            return (
                <>
                    <div style={{maxWidth: 850, marginLeft: "auto", marginRight: "auto"}}>
                        <div style={{marginTop: 30}}>
                            {view}
                        </div>
                    </div>
                </>
            )
        }
        return null;
    }
}

const styles = theme => ({
    table_head: {
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText
    },
    table_head_amount: {
        textAlign: 'right',
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText
    },
    table_amount: {
        textAlign: 'right',
        fontSize: 15
    },
    table_row: {
        fontSize: 15
    },
    titleTextStyle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        bold: true,
        marginBottom: 15
    }
});

MyPOSInEventTable.defaultProps= {
    myposInEvent: {}
};

export default withStyles(styles)(MyPOSInEventTable);
